import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

interface FilterToggleProps {
  id: string;
  label: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export function FilterToggle({ id, label, checked, onCheckedChange }: FilterToggleProps) {
  return (
    <div className="flex items-center gap-3 p-3 rounded-xl bg-gradient-to-r from-emerald-50 to-teal-50 dark:from-emerald-950/20 dark:to-teal-950/20 border border-emerald-200 dark:border-emerald-700/50 transition-all duration-300 hover:shadow-md hover:shadow-emerald-500/10 dark:hover:shadow-emerald-400/20 hover:from-emerald-100 hover:to-teal-100 dark:hover:from-emerald-950/40 dark:hover:to-teal-950/40 hover:border-emerald-300 dark:hover:border-emerald-600/70 filter-toggle">
      <Switch
        checked={checked}
        onCheckedChange={onCheckedChange}
        id={id}
        className="data-[state=checked]:bg-emerald-500 data-[state=unchecked]:bg-slate-300 dark:data-[state=unchecked]:bg-gray-600"
      />
      <Label
        htmlFor={id}
        className="text-sm font-medium text-slate-700 dark:text-gray-300 cursor-pointer transition-colors duration-300"
      >
        {label}
      </Label>
    </div>
  );
}
